import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type UpsertCustomBrandingMutationVariables = Types.Exact<{
  input: Types.UpsertCustomBrandingInput;
}>;


export type UpsertCustomBrandingMutation = { __typename?: 'Mutation', upsertCustomBranding: { __typename?: 'CustomBranding', tenantId: string, tenantName?: string | null, faviconUrl?: string | null, faviconFileUuid?: string | null, logoUrl?: string | null, logoFileUuid?: string | null, primaryColor?: string | null, isClinicNameShownInSidebar: boolean } };

export type GetCustomBrandingQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomBrandingQuery = { __typename?: 'Query', Tenant: { __typename?: 'TenantQueries', customBranding?: { __typename?: 'CustomBranding', tenantId: string, tenantName?: string | null, faviconUrl?: string | null, faviconFileUuid?: string | null, logoUrl?: string | null, logoFileUuid?: string | null, primaryColor?: string | null, isClinicNameShownInSidebar: boolean } | null } };

export type GetCustomBrandingBySlugQueryVariables = Types.Exact<{
  input: Types.BrandingSlugInput;
}>;


export type GetCustomBrandingBySlugQuery = { __typename?: 'Query', Tenant: { __typename?: 'TenantQueries', customBrandingBySlug?: { __typename?: 'CustomBranding', tenantId: string, tenantName?: string | null, faviconUrl?: string | null, faviconFileUuid?: string | null, logoUrl?: string | null, logoFileUuid?: string | null, primaryColor?: string | null, isClinicNameShownInSidebar: boolean } | null } };

export type GetCustomVirtualBackgroundsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetCustomVirtualBackgroundsQuery = { __typename?: 'Query', Tenant: { __typename?: 'TenantQueries', customVirtualBackgrounds: Array<{ __typename?: 'CustomVirtualBackground', id: string, url: string, fileUuid: string, source: Types.CustomVirtualBackgroundSource, brandedVariant?: Types.BrandedVirtualBackgroundVariant | null }> } };


export const UpsertCustomBrandingDocument = `
    mutation upsertCustomBranding($input: UpsertCustomBrandingInput!) {
  upsertCustomBranding(input: $input) {
    tenantId
    tenantName
    faviconUrl
    faviconFileUuid
    logoUrl
    logoFileUuid
    primaryColor
    isClinicNameShownInSidebar
  }
}
    `;
export const GetCustomBrandingDocument = `
    query getCustomBranding {
  Tenant {
    customBranding {
      tenantId
      tenantName
      faviconUrl
      faviconFileUuid
      logoUrl
      logoFileUuid
      primaryColor
      isClinicNameShownInSidebar
    }
  }
}
    `;
export const GetCustomBrandingBySlugDocument = `
    query getCustomBrandingBySlug($input: BrandingSlugInput!) {
  Tenant {
    customBrandingBySlug(input: $input) {
      tenantId
      tenantName
      faviconUrl
      faviconFileUuid
      logoUrl
      logoFileUuid
      primaryColor
      isClinicNameShownInSidebar
    }
  }
}
    `;
export const GetCustomVirtualBackgroundsDocument = `
    query getCustomVirtualBackgrounds {
  Tenant {
    customVirtualBackgrounds {
      id
      url
      fileUuid
      source
      brandedVariant
    }
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    upsertCustomBranding: build.mutation<UpsertCustomBrandingMutation, UpsertCustomBrandingMutationVariables>({
      query: (variables) => ({ document: UpsertCustomBrandingDocument, variables })
    }),
    getCustomBranding: build.query<GetCustomBrandingQuery, GetCustomBrandingQueryVariables | void>({
      query: (variables) => ({ document: GetCustomBrandingDocument, variables })
    }),
    getCustomBrandingBySlug: build.query<GetCustomBrandingBySlugQuery, GetCustomBrandingBySlugQueryVariables>({
      query: (variables) => ({ document: GetCustomBrandingBySlugDocument, variables })
    }),
    getCustomVirtualBackgrounds: build.query<GetCustomVirtualBackgroundsQuery, GetCustomVirtualBackgroundsQueryVariables | void>({
      query: (variables) => ({ document: GetCustomVirtualBackgroundsDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useUpsertCustomBrandingMutation, useGetCustomBrandingQuery, useLazyGetCustomBrandingQuery, useGetCustomBrandingBySlugQuery, useLazyGetCustomBrandingBySlugQuery, useGetCustomVirtualBackgroundsQuery, useLazyGetCustomVirtualBackgroundsQuery } = injectedRtkApi;

